import defaultTheme from './default';
import successTheme from './success';
import secondaryTheme from './secondary';
import darkTheme from './dark';

import { createTheme } from '@mui/material/styles';

const overrides = {
  typography: {
    fontSize: 12, // Reduced by 15% total (was 13)
    h1: {
      fontSize: '2.08rem', // Reduced by 15% total (was 2.5rem)
    },
    h2: {
      fontSize: '1.46rem', // Reduced by 15% total (was 1.75rem)
    },
    h3: {
      fontSize: '1.25rem', // Reduced by 15% total (was 1.5rem)
    },
    h4: {
      fontSize: '1.04rem', // Reduced by 15% total (was 1.25rem)
    },
    h5: {
      fontSize: '0.92rem', // Reduced by 15% total (was 1.125rem)
    },
    h6: {
      fontSize: '0.83rem', // Reduced by 15% total (was 1rem)
    },
    body1: {
      fontSize: '0.72rem', // Reduced by 15% total (was 0.875rem)
    },
    body2: {
      fontSize: '0.67rem', // Reduced by 15% total (was 0.8125rem)
    },
    button: {
      fontSize: '0.67rem', // Reduced by 15% total (was 0.8125rem)
    },
    caption: {
      fontSize: '0.58rem', // Reduced by 15% total (was 0.6875rem)
    },
  },
  overrides: {
    MuiCard: {
      root: {
        boxShadow:
          '0px 3px 11px 0px #E8EAFC, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A',
      },
    },
    MUIDataTable: {
      paper: {
        boxShadow:
          '0px 3px 11px 0px #E8EAFC, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A',
      },
    },
    MuiBackdrop: {
      root: {
        backgroundColor: '#4A4A4A1A',
      },
    },
    MuiMenu: {
      paper: {
        boxShadow:
          '0px 3px 11px 0px #E8EAFC, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A',
      },
    },
    MuiSelect: {
      icon: {
        color: '#B9B9B9',
      },
    },
    MuiListItem: {
      root: {
        '&$selected': {
          backgroundColor: '#F3F5FF !important',
          '&:focus': {
            backgroundColor: '#F3F5FF',
          },
        },
      },
      button: {
        '&:hover, &:focus': {
          backgroundColor: '#F3F5FF',
        },
      },
    },
    MuiTouchRipple: {
      child: {
        backgroundColor: 'white',
      },
    },
    MuiTableRow: {
      root: {
        height: 48, // Reduced from 56 for more compact tables
      },
    },
    MuiTableCell: {
      root: {
        borderBottom: '1px solid rgba(224, 224, 224, .5)',
        padding: '12px 32px 12px 20px', // Reduced padding for compact display
      },
      head: {
        fontSize: '0.67rem', // Reduced by 15% total (was 0.8125rem)
      },
      body: {
        fontSize: '0.67rem', // Reduced by 15% total (was 0.8125rem)
      },
      paddingCheckbox: {
        padding: '0 0 0 12px',
      },
    },
  },
  components: {
    MuiTablePagination: {
      defaultProps: {
        rowsPerPageOptions: [10, 20, 50, 100, 500, 1000],
      },
    },
  },
};

const darkModeOverrides = {
  components: {
    MuiCssBaseline: {
      '@global': {
        // '*': {
        //     'scrollbar-width': 'thin',
        // },
        '*::-webkit-scrollbar': {
          width: '0.4em',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#12121A',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: '#23232D',
          boxShadow:
            '0px 1px 8px rgba(0, 0, 0, 0.103475), 0px 3px 3px rgba(0, 0, 0, 0.0988309), 0px 3px 4px rgba(0, 0, 0, 0.10301) !important',
          '&::-webkit-scrollbar': {
            width: '0.4em',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#12121A',
          },
        },
      },
    },
    MuiAppBar: {
      root: {
        backgroundColor: '#23232D !important',
      },
    },
    MuiButton: {
      root: {
        boxShadow: 'none !important',
      },
    },
    typography: {
      root: {
        color: 'white !important',
      },
    },
    MuiCheckbox: {
      root: {
        color: '#76767B',
      },
    },
    MuiTable: {
      root: {
        '&::-webkit-scrollbar': {
          width: '0.4em',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#12121A',
        },
      },
    },
    MuiTableCell: {
      head: {
        color: '#76767B',
      },
    },
    MuiTableBody: {
      root: {
        '&::-webkit-scrollbar': {
          width: '0.4em',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#12121A',
        },
      },
    },
    MuiTableSortLabel: {
      icon: {
        color: '#76767B',
      },
      active: {
        color: '#76767B !important',
      },
      iconDirectionDesc: {
        color: '#76767B !important',
      },
      iconDirectionAsc: {
        color: '#76767B !important',
      },
    },
    MuiTablePagination: {
      defaultProps: {
        rowsPerPageOptions: [10, 20, 50, 100, 500, 1000],
      },
      toolbar: {
        color: '#76767B',
      },
      selectIcon: {
        color: '#76767B',
      },
    },
  },
};

export default {
  default: createTheme({ ...defaultTheme, ...overrides }),
  secondary: createTheme({ ...secondaryTheme, ...overrides }),
  success: createTheme({ ...successTheme, ...overrides }),
  dark: createTheme({ ...darkTheme, ...overrides, ...darkModeOverrides }),
};
